import { CSSProperties } from 'react';
import { CONSTANTS } from '../../UIConstants';

export const navLinksContainer: CSSProperties = {
    display: CONSTANTS.DISPLAY.FLEX,
    alignItems: CONSTANTS.FLEX_ALIGN.CENTER,
    flexDirection: CONSTANTS.FLEX_DIRECTION.ROW,
    color: CONSTANTS.COLORS.DARK_GREY,
    height: 95,
    fontSize: CONSTANTS.FONT_SIZE.LARGE,
    flexShrink: 0,
    paddingRight: 100,
    paddingLeft: 100,
    boxShadow: CONSTANTS.BOX_SHADOW.PANEL,
    paddingBottom: 2
};

export const activeNavStyle: CSSProperties = {
    color: CONSTANTS.COLORS.THEME_BLUE,
    fontWeight: 600,
    textDecoration: 'none',
    paddingRight: 10,
    borderBottom: '4px solid ' + CONSTANTS.COLORS.THEME_BLUE,
    height: 100 + '%',
    display: CONSTANTS.DISPLAY.FLEX,
    flexDirection: CONSTANTS.FLEX_DIRECTION.ROW,
    alignItems: CONSTANTS.FLEX_ALIGN.CENTER,
    marginLeft: 50
};

export const normalStyle: CSSProperties = {
    color: CONSTANTS.COLORS.BORDER_GREY,
    textDecoration: 'none',
    height: 100 + '%',
    paddingRight: 10,
    display: CONSTANTS.DISPLAY.FLEX,
    flexDirection: CONSTANTS.FLEX_DIRECTION.ROW,
    alignItems: CONSTANTS.FLEX_ALIGN.CENTER,
    marginLeft: 50,
    borderBottom: '4px solid ' + CONSTANTS.COLORS.WHITE
};

export const iconContainer: CSSProperties = {
    marginRight: 20
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/styles/Layout/NavLinks.ts